export default "__VITE_ASSET__D6DeHT98__"